import React, { useState }  from 'react';
import { Space, message, Breadcrumb, Table, Spin } from 'antd';
import { CardLayout, TableWrapper } from 'components/molecules';
import { addNewSearch } from 'utils/utils';
import { useLocation, useNavigate } from 'react-router';
import { usePopupManager } from 'react-popup-manager';
import { ColumnsType } from 'antd/lib/table/interface';
import qs from 'query-string';
import { TotalNumMenu } from 'components/atoms';
import { useTableInfo, useMailing } from 'hooks';
import { INIT_PAGESIZE } from 'commons/constants';
import MailingSearchBox from './SearchBox'
import axios from 'axios';
import { endpoints } from 'services';
import { SERVER_URL } from 'commons/constants';
import moment from 'moment';
import { fetcher } from 'services';
import * as XLSX from 'xlsx';

export interface  MailingProps {}

const  Mailing = ({}:  MailingProps): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
 const navigate = useNavigate();
 const location = useLocation();
 const { mailingList, searchResult } = useMailing();  

 /* ======================================================
  * variables
  * ====================================================== */
 const { open } = usePopupManager();
 const [isLoding, setIsLoading] = useState<boolean>(false);   

 const searchParams = qs.parse(location.search);
 const columns: ColumnsType<MailingListDto> = [
   {
     title: '번호',
     dataIndex: 'id',
     key: 'id',
     width: '70px',
     align: 'center',
   },  
   {
     title: '소속',
     dataIndex: 'company',
     key: 'company',
     width: '250px',
     align: 'left', 
     ellipsis: true,    
   },  
   {
    title: '부서',
    dataIndex: 'department',
    key: 'department',
    width: '150px',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '이름',
    dataIndex: 'name',
    key: 'name',
    width: '150px',
    align: 'center',
    ellipsis: true,
  },
   {
     title: '이메일',
     dataIndex: 'email',
     key: 'email',
     width: 'auto',
     align: 'left',
     ellipsis: true,
   },
   {
    title: '등록일시',
    dataIndex: 'created_at',
    key: 'created_at',
    width: '150px',
    align: 'center',
    ellipsis: true,
  },   
 ];

 /* ======================================================
  * events
  * ====================================================== */    
 
 const onChangePageInfo = (pageNo: number, pageSize: number) => {
   navigate({
     ...location,
     search: addNewSearch(location.search, { pageNo, pageSize }),
   });
 };  

 const onExcelDownload = () => {
  setIsLoading(true); 
  fetcher.mailing.postMailingList({
    pageNo: 1,
    pageSize: 0,
    searchValue: searchParams.search ? String(searchParams.search) : '',        
    searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : '',   
    searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : '',  
  })
  .then((res) => {
      switch (res.code) {
          case 200:
          if (!!res.result) {
            const book = XLSX.utils.book_new();
            const nurses = XLSX.utils.json_to_sheet(
              res.result.list.map((item, index) => {
                return {
                  '구분1' : '',
                  '구분2' : '',
                  '구분3': '',
                  '구분4': '',
                  '회사명': item.company,
                  '법인명 사업자등록증': '',
                  '부서': item.department,
                  '이름': item.name,
                  '직급': '',
                  '회사전화': '',
                  '휴대폰': '',
                  '이메일': item.email,
                  'FAX': '',
                  '지역': '',
                  '우편번호': '',
                  '주소': '',
                  '신규등록일': item.created_at,
                }
              }), 
              { 
                header : [
                  '구분1',
                  '구분2',
                  '구분3',
                  '구분4',
                  '회사명',
                  '법인명 사업자등록증',
                  '부서',
                  '이름',
                  '직급',
                  '회사전화',
                  '휴대폰',
                  '이메일',
                  'FAX',
                  '지역',
                  '우편번호',
                  '주소',
                  '신규등록일',
                ], 
                skipHeader : false 
              } 
            );
        
            nurses["!cols"] = [
              { wpx : 100 } 
            , { wpx : 100 } 
            , { wpx : 100 }  
            , { wpx : 100 } 
            , { wpx : 150 } 
            , { wpx : 150 } 
            , { wpx : 120 } 
            , { wpx : 100 } 
            , { wpx : 100 } 
            , { wpx : 100 } 
            , { wpx : 100 } 
            , { wpx : 150 } 
            , { wpx : 100 } 
            , { wpx : 100 } 
            , { wpx : 100 } 
            , { wpx : 100 } 
            , { wpx : 100 } 
            ]
        
            XLSX.utils.book_append_sheet( book, nurses, "NURSES" );
        
            XLSX.writeFile( book, "고객_지식수.xlsx" ); 
          }
          break;
          default:  
          break;
      };
      setIsLoading(false);         
  });   
 }  

  /* ======================================================
   * hooks
   * ====================================================== */
  const { pagination, onTableChange } = useTableInfo({
    pageInfo: {
      pageNo: Number(searchParams.pageNo) || 1,
      pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
    },
    datas: mailingList,
    totalCount: searchResult.totalCount,
    onChangePageInfo,
  });

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>고객</Breadcrumb.Item>
        <Breadcrumb.Item>지식수</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <MailingSearchBox />
          <Spin spinning={isLoding} tip="처리중입니다. 잠시만 기다려 주세요." size="large">
            <TotalNumMenu totalNum={searchResult.totalCount} useExcelDownload onDownloadExcel={onExcelDownload}/>
            <TableWrapper isSearch={!!searchParams.search || !!searchParams.lecturer_type || !!searchParams.lecturer_category}>
              <Table
                tableLayout="fixed"
                dataSource={mailingList}
                columns={columns}
                pagination={pagination}
                onChange={onTableChange}
                style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
                showSorterTooltip={false}
                rowKey={'id'}
              />
            </TableWrapper>  
          </Spin>
        </Space>               
    </CardLayout>
  )
};

export default  Mailing;    